import { useTranslation } from 'react-i18next';

import { Settings } from 'luxon';
import store from 'store';

import { getLanguageForService } from '@common/helpers/serviceLanguages';

export default () => {
	const { i18n } = useTranslation();

	const serviceChange = (id: number) => {
		const currentLanguage = i18n.language;
		const language = getLanguageForService(currentLanguage, id);

		if (currentLanguage !== language) {
			store.profile.changeUserLanguage(language);
			i18n.changeLanguage(language);
			Settings.defaultLocale = language;
		}
		store.services.select(id);
	};

	return serviceChange;
};
